import { useMutation } from '@tanstack/react-query'

import { parseOrganizationChartForWorkflow } from '@src/api'
import { DefaultApiParseOrganizationChartForWorkflowRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useParseOrganizationChartForWorkflow = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiParseOrganizationChartForWorkflowRequest) =>
      parseOrganizationChartForWorkflow(axiosInstance, params),
  })
}
